import React, { useState, useEffect, useMemo } from 'react';
import PageHeading from '../../components/PageHeading';
import { SearchOutlined, EditOutlined, DeleteOutlined, AlipayOutlined, ClockCircleOutlined } from '@ant-design/icons';
import axiosInstance from '../../utils/axios';
import { Button, Input, message, Popconfirm, Table } from 'antd';
import { dateFormat } from '../../utils/dateFormats';
import StateModal from './StateModal';
// import TimeSlotModal from './TimeSlotModal';

const States = () => {
    const [states, setStates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        fetchData();
        fetchCountries();
    }, []);

    const openModalUpdate = (id) => {
        setSelectedId(id);
        setCreateModalOpen(true);
    };

    const openModalCreate = () => {
        setSelectedId(null);
        setCreateModalOpen(true);
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get("core/state/");
            setStates(response.data);
        } catch (error) {
            message.error("Failed to fetch states");
        } finally {
            setLoading(false);
        }
    };

    const fetchCountries = async () => {
        try {
            const response = await axiosInstance.get("core/country/");
            setCountries(response.data);
        } catch (error) {
            message.error("Failed to fetch states");
        } 
    }

    const cancel = () => message.info('Cancelled');

    const confirm = async (id) => {
        try {
            await axiosInstance.delete(`core/state/${id}/`);
            message.success("Deleted successfully");
            setStates(prev => prev.filter(item => item.id !== id));
        } catch (err) {
            message.error("Cannot delete");
        }
    };

    const filteredlanguages = useMemo(() => {
        return states.filter(item =>
            item.name.toLowerCase().includes(search.toLowerCase())
        );
    }, [search, states]);

    const fetchName = () => {
        if (countries.length > 0)
            return countries[0].name;
        else
            return '';
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Created at',
            dataIndex: 'created_at',
            key: 'created_at',
            render: text => dateFormat(text),
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'actions',
            render: (_, record) => record.restricted ? null : (
                <>
                    <Button type="link" icon={<EditOutlined />}  onClick={() => openModalUpdate(record.id)} />
                    <Popconfirm
                        title="Delete"
                        description="Are you sure to delete this item?"
                        onConfirm={() => confirm(record.id)}
                        onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="link" danger icon={<DeleteOutlined />} />
                    </Popconfirm>
                </>
            )
        },
    ];

    return (
        <div className='dashboard'>
            <PageHeading name={`${fetchName()}'s states`} icon={<ClockCircleOutlined />} />

            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '12px',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 16
            }}>
                <Input
                    placeholder="Search here"
                    prefix={<SearchOutlined />}
                    style={{ width: "190px" }}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <Button type="primary" onClick={openModalCreate}>Add new</Button>
            </div>

            <Table
                dataSource={filteredlanguages}
                loading={loading}
                columns={columns}
                rowKey="id"
                pagination
            />

            <StateModal
                open={createModalOpen}
                setOpen={setCreateModalOpen}
                states={states}
                setStates={setStates}
                selectedId={selectedId}
                countries={countries}
            />
        </div>
    )
}

export default States